import { render, staticRenderFns } from "./UserSidebarWidget.vue?vue&type=template&id=cf75df9e&"
import script from "./UserSidebarWidget.vue?vue&type=script&lang=js&"
export * from "./UserSidebarWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserSidebarWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports